import { Typography } from '@mui/material'
import styled from 'styled-components'

export const ExportFormatTypographyStyled = styled(Typography)`
  margin-left: ${({ theme }) => theme.spacing(0.5)};
  color: ${({ theme }) => theme.colors.text.secondary};
`
